module.exports = __webpack_public_path__ + "static/img/7.1cead51.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/sp/7.png
// module id = LpCE
// module chunks = 0